import { Component, Input } from "@angular/core";
import { FaIconComponent } from "@fortawesome/angular-fontawesome";

@Component({
    selector: "app-teitl-tudalen",
    templateUrl: "./teitl-tudalen.component.html",
    styleUrl: "./teitl-tudalen.component.scss",
    imports: [FaIconComponent],
})
export class TeitlTudalenComponent {
  @Input() teitl: string;
  @Input() eicon: string;
}
